module.exports = __webpack_public_path__ + "gallery-v2.img.default-content.1cb9cf3703ba7cc2e685607c55ab4fff.jpg";